import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./routes/Home";
import SurveyEstimate from './routes/SurveyEstimate';
import DesignEstimate from './routes/DesignEstimate';
import History from './routes/History';
import Greetings from './routes/Greetings';
import OrgChart from './routes/OrgChart';
import BizzIntroSurvey from './routes/BizzIntroSurvey';
import BizzIntroDesign from './routes/BizzIntroDesign';
import SurveyEstimateDetailRoute from './routes/SurveyEstimateDetailRoute';
import DesignEstimateDetailRoute from './routes/DesignEstimateDetailRoute';
import PerfPoint from './routes/PerfPoint';
import PerfPointDetailRoute from './routes/PerfPointDetailRoute';
import PerfGeneral from './routes/PerfGeneral';
import PerfGeneralDetailRoute from './routes/PerfGeneralDetailRoute';
import PerfCivil from './routes/PerfCivil';
import PerfCivilDetailRoute from './routes/PerfCivilDetailRoute';
import PerfEtc from './routes/PerfEtc';
import PerfEtcDetailRoute from './routes/PerfEtcDetailRoute';
import Notice from './routes/Notice';
import NoticeDetailRoute from './routes/NoticeDetailRoute';
import Guide from './routes/Guide';
import Locate from './routes/Lacate';
import Login from './routes/Login';
import '../src/assets/css/style.css';
import '../src/assets/js/nav.js';
import * as zy from './common/zeroyear-1.0.0';


function App() {
  zy.navFuc();

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home/>}></Route>
          <Route path="/index.php" element={<Home/>}></Route>
          <Route path="/SurveyEstimate" element={<SurveyEstimate/>}></Route>
          <Route path="/DesignEstimate" element={<DesignEstimate/>}></Route>
          <Route path="/History" element={<History/>}></Route>
          <Route path="/Greetings" element={<Greetings/>}></Route>
          <Route path="/OrgChart" element={<OrgChart/>}></Route>
          <Route path="/BizzIntroSurvey" element={<BizzIntroSurvey/>}></Route>
          <Route path="/BizzIntroDesign" element={<BizzIntroDesign/>}></Route>
          <Route path="/SurveyEstimateDetailRoute/:id" element={<SurveyEstimateDetailRoute/>}></Route>
          <Route path="/DesignEstimateDetailRoute/:id" element={<DesignEstimateDetailRoute/>}></Route>
          <Route path="/PerfPoint" element={<PerfPoint/>}></Route>
          <Route path="/PerfPointDetailRoute/:id" element={<PerfPointDetailRoute/>}></Route>
          <Route path="/PerfGeneral" element={<PerfGeneral/>}></Route>
          <Route path="/PerfGeneralDetailRoute/:id" element={<PerfGeneralDetailRoute/>}></Route>
          <Route path="/PerfCivil" element={<PerfCivil/>}></Route>
          <Route path="/PerfCivilDetailRoute/:id" element={<PerfCivilDetailRoute/>}></Route>
          <Route path="/PerfEtc" element={<PerfEtc/>}></Route>
          <Route path="/PerfEtcDetailRoute/:id" element={<PerfEtcDetailRoute/>}></Route>
          <Route path="/Notice" element={<Notice/>}></Route>
          <Route path="/NoticeDetailRoute/:id" element={<NoticeDetailRoute/>}></Route>
          <Route path="/Guide" element={<Guide/>}></Route>
          <Route path="/Locate" element={<Locate/>}></Route>
          <Route path="/Admin/Login" element={<Login/>}></Route>
        </Routes>
      </BrowserRouter>
    </>
  )
  ;
}

export default App;
